import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import useStyles from './Logo.styles';

export const LogoComponent = ({ alt, src }) => {
  const { link, logo } = useStyles();
  return (
    <Link to="/dashboard" className={link}>
      <img className={logo} src={src} alt={alt} />
    </Link>
  );
};

LogoComponent.propTypes = {
  src: PropTypes.string,
  alt: PropTypes.string
};

LogoComponent.defaultProps = {
  alt: '',
  src: ''
};
export default LogoComponent;
